import { Fragment, useContext, useState } from "react";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import CarrionList from "./CarrionList";

const CarrionListWrapper = () => {

    // STATES

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenImport, setIsOpenImport] = useState(false);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de carroñas' },
        { name: 'Carroñas', href: menuRoutes.carrion.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de carroñas" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'carrion') &&
                        (
                            <div className="flex flex-col md:flex-row gap-2">
                                {/*
                                <Button
                                    color="primary"
                                    onClick={() => { setIsOpenImport(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Importar carroñas
                                </Button>
                                */}
                                <Button
                                    color="primary"
                                    onClick={() => {  setIsOpen(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear carroña
                                </Button>
                            </div>
                        )
                    }

                </PageHeader>
                <CarrionList
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    isOpenImport={isOpenImport}
                    setIsOpenImport={setIsOpenImport}
                />
            </FiltersProvider>

        </Fragment>
    );
}

export default CarrionListWrapper;
